import { render, staticRenderFns } from "./obituary1.vue?vue&type=template&id=7e2209bf&scoped=true&"
import script from "./obituary1.vue?vue&type=script&lang=js&"
export * from "./obituary1.vue?vue&type=script&lang=js&"
import style0 from "./obituary1.vue?vue&type=style&index=0&id=7e2209bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2209bf",
  null
  
)

export default component.exports